import React from 'react';
import { connect } from 'react-redux';
import PieChart from '../../../Charts/PieChart';
import * as actions from '../../../../store/actions/index';

const PieChequesPropiosPorEmpresa = (props) => {

  const handlePorcionClick = (config) => {
    props.onPorcionClick(config);
  };

  return (
    <PieChart
      title={props.title}
      subTitle={props.subtitle}
      series={props.cheques.map((cheque) => cheque.total)}
      labels={props.cheques.map((cheque) => cheque.nombreEmpresa)}
      ids={props.cheques.map((cheque) => cheque.id)}
      loading={props.loading}
      imgSinDatos={props.totalCheques <= 0}
      chartType={'pie'}
      height={props.height}
      width={'100%'}
      disabled={props.estaOculto}
      onPorcionClick={handlePorcionClick}
      onChangeViewClick={props.onChangeViewClick}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    cheques: state.multiempresa.chequesPropiosPorEmpresa.cheques,
    loading: state.multiempresa.chequesPropiosPorEmpresa.loading,
    totalCheques: state.multiempresa.chequesPropiosPorEmpresa.totalCheques,
    estaCargado: state.multiempresa.chequesPropiosPorEmpresa.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.chequesEmitidosPendientesMultiempresa
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: () => dispatch(actions.loadChequesPropiosPorEmpresa())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PieChequesPropiosPorEmpresa);
